'use strict';
module.exports = require('./ScrollTop.vue');